import React, { useEffect } from 'react'
import { ServiceType, SortByOptions } from 'enums'

import { createFingerprintRetrieval } from 'utils/runSearchUtil'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { useAppDispatch } from 'app/hooks'
import { getCountryFilterKey } from 'utils/getCountryFilterKeyUtil'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { InsightContentSettingType } from '../types'
import { SoundbitesSortTypeStrings } from '../enum/SoundbitesSortType'

const DEFAULT_SOUNDBITE_COUNT = 25
const IGNORE_SENTIMENT = true

const createSearch = (
  detailSetting: InsightContentSettingType,
  sortBy: SoundbitesSortTypeStrings,
  includeHeaderTweet: boolean
) => {
  if (!detailSetting || !detailSetting.topicId || detailSetting.emptyInsight) {
    throw new Error('Invalid Search')
  }

  const filter = detailSetting.selectionFilter || detailSetting.filter

  if (detailSetting.region) {
    filter.countries = filter.countries || []
    const regionFilter = getCountryFilterKey(detailSetting.region)
    if (regionFilter) {
      filter.countries.push([regionFilter])
    }
  }

  return createFingerprintRetrieval(
    ServiceType.SENTENCE_RETRIEVAL,
    -1,
    '',
    [detailSetting.topicId!],
    filter,
    detailSetting.precision!,
    sortBy || SortByOptions.RICHNESS,
    DEFAULT_SOUNDBITE_COUNT,
    IGNORE_SENTIMENT,
    includeHeaderTweet
  )
}

const RunSearchEffect = ({
  detailSetting,
  sortBy,
  includeHeaderTweet = false,
  children
}: {
  detailSetting: InsightContentSettingType
  sortBy: SoundbitesSortTypeStrings
  includeHeaderTweet?: boolean
  children: React.ReactNode
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearch(detailSetting, sortBy, includeHeaderTweet)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.SOUND_BITE,
        searches: [searches!],
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, sortBy, includeHeaderTweet, refreshTimestamp])

  return <>{children}</>
}

export default RunSearchEffect
